import React from 'react';
import theme from 'shared/constants/theme.json';

export default () => {
  const textSecondary = theme['text-color-secondary'];
  const textColor = theme['text-color'];
  const borderColor = theme['border-color-base'];
  const primaryColor = theme['primary-color'];

  return (
    <svg width="234" height="288" viewBox="0 0 234 288" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="201.682" height="258.603" fill="white" />
      <path d="M39 25H175.407M76.8355 41.5854H136.576" stroke={textSecondary} strokeWidth="3" />
      <path d="M12.6294 128.833V63.1021L100.626 96.1715L12.6294 128.833ZM13.7051 129.5L102.054 96.7081L189.313 129.5H13.7051ZM190.369 128.829L103.484 96.1773L190.369 63.929V128.829ZM190.369 62.8623L102.056 95.6407L13.8698 62.5H190.369V62.8623Z" stroke={textSecondary} />
      <path d="M22.1059 164.024H56.9543V162.073H22.1059V164.024Z" fill={textSecondary} />
      <path d="M60.937 171.829H16.1318V170.854H60.937V171.829Z" fill={textSecondary} />
      <path d="M55.9587 183.537H16.1318V182.561H55.9587V183.537Z" fill={textSecondary} />
      <path d="M16.1318 195.244H60.937V194.268H16.1318V195.244Z" fill={textSecondary} />
      <path d="M60.937 206.951H16.1318V205.976H60.937V206.951Z" fill={textSecondary} />
      <path d="M16.1318 175.732H50.9803V174.756H16.1318V175.732Z" fill={textSecondary} />
      <path d="M50.9803 187.439H16.1318V186.463H50.9803V187.439Z" fill={textSecondary} />
      <path d="M16.1318 199.146H50.9803V198.171H16.1318V199.146Z" fill={textSecondary} />
      <path d="M50.9803 210.854H16.1318V209.878H50.9803V210.854Z" fill={textSecondary} />
      <path d="M16.1318 179.634H60.937V178.659H16.1318V179.634Z" fill={textSecondary} />
      <path d="M55.9587 191.341H16.1318V190.366H55.9587V191.341Z" fill={textSecondary} />
      <path d="M16.1318 203.049H55.9587V202.073H16.1318V203.049Z" fill={textSecondary} />
      <path d="M60.937 214.756H16.1318V213.78H60.937V214.756Z" fill={textSecondary} />
      <path d="M22.1059 164.024H56.9543V162.073H22.1059V164.024Z" stroke={textSecondary} />
      <path d="M60.937 171.829H16.1318V170.854H60.937V171.829Z" stroke={textSecondary} />
      <path d="M55.9587 183.537H16.1318V182.561H55.9587V183.537Z" stroke={textSecondary} />
      <path d="M16.1318 195.244H60.937V194.268H16.1318V195.244Z" stroke={textSecondary} />
      <path d="M60.937 206.951H16.1318V205.976H60.937V206.951Z" stroke={textSecondary} />
      <path d="M16.1318 175.732H50.9803V174.756H16.1318V175.732Z" stroke={textSecondary} />
      <path d="M50.9803 187.439H16.1318V186.463H50.9803V187.439Z" stroke={textSecondary} />
      <path d="M16.1318 199.146H50.9803V198.171H16.1318V199.146Z" stroke={textSecondary} />
      <path d="M50.9803 210.854H16.1318V209.878H50.9803V210.854Z" stroke={textSecondary} />
      <path d="M16.1318 179.634H60.937V178.659H16.1318V179.634Z" stroke={textSecondary} />
      <path d="M55.9587 191.341H16.1318V190.366H55.9587V191.341Z" stroke={textSecondary} />
      <path d="M16.1318 203.049H55.9587V202.073H16.1318V203.049Z" stroke={textSecondary} />
      <path d="M60.937 214.756H16.1318V213.78H60.937V214.756Z" stroke={textSecondary} />
      <rect x="0.5" y="0.5" width="201.682" height="258.603" stroke={borderColor} />
      <g filter="url(#filter0_d)">
        <g clipPath="url(#clip0)">
          <rect x="71.3793" y="94.5695" width="158.621" height="185.43" rx="2" fill="white" />
          <line x1="87.3793" y1="246.07" x2="177.379" y2="246.07" stroke={textColor} strokeWidth="3" />
          <line x1="95.3793" y1="257.07" x2="140.379" y2="257.07" stroke={textSecondary} />
          <line x1="95.3793" y1="263.07" x2="127.379" y2="263.07" stroke={textSecondary} />
          <line x1="95.3793" y1="269.07" x2="145.379" y2="269.07" stroke={textSecondary} />
          <circle cx="89.3793" cy="256.57" r="2" fill="white" />
          <circle cx="89.3793" cy="256.57" r="1.9" stroke={textSecondary} strokeWidth="0.2" />
          <circle cx="89.3793" cy="262.57" r="2" fill="white" />
          <circle cx="89.3793" cy="262.57" r="1.9" stroke={textSecondary} strokeWidth="0.2" />
          <circle cx="89.3793" cy="268.57" r="2" fill="white" />
          <circle cx="89.3793" cy="268.57" r="1.9" stroke={textSecondary} strokeWidth="0.2" />
          <line x1="87.3793" y1="209.07" x2="177.379" y2="209.07" stroke={textColor} strokeWidth="3" />
          <line x1="97.3793" y1="219.07" x2="142.379" y2="219.07" stroke={textSecondary} />
          <line x1="97.3793" y1="225.07" x2="129.379" y2="225.07" stroke={textSecondary} />
          <line x1="97.3793" y1="231.07" x2="137.379" y2="231.07" stroke={textSecondary} />
          <rect x="87.3793" y="216.57" width="4" height="4" fill="white" />
          <rect x="87.4793" y="216.67" width="3.8" height="3.8" stroke={textSecondary} strokeWidth="0.2" />
          <rect x="87.3793" y="222.57" width="4" height="4" fill="white" />
          <rect x="87.4793" y="222.67" width="3.8" height="3.8" stroke={textSecondary} strokeWidth="0.2" />
          <rect x="87.3793" y="228.57" width="4" height="4" fill="white" />
          <rect x="87.4793" y="228.67" width="3.8" height="3.8" stroke={textSecondary} strokeWidth="0.2" />
          <line x1="87.3793" y1="163.07" x2="152.379" y2="163.07" stroke={textColor} strokeWidth="3" />
          <rect x="87.3793" y="169.57" width="136" height="26" rx="1" fill="white" />
          <rect x="87.4793" y="169.67" width="135.8" height="25.8" rx="0.9" stroke={textSecondary} strokeWidth="0.2" />
          <line x1="87.3793" y1="125.07" x2="177.379" y2="125.07" stroke={textColor} strokeWidth="3" />
          <line x1="95.3793" y1="136.07" x2="140.379" y2="136.07" stroke={textSecondary} />
          <line x1="95.3793" y1="142.07" x2="127.379" y2="142.07" stroke={textSecondary} />
          <line x1="95.3793" y1="148.07" x2="145.379" y2="148.07" stroke={textSecondary} />
          <circle cx="89.3793" cy="135.57" r="2" fill="white" />
          <circle cx="89.3793" cy="135.57" r="1.9" stroke={textSecondary} strokeWidth="0.2" />
          <circle cx="89.3793" cy="141.57" r="2" fill="white" />
          <circle cx="89.3793" cy="141.57" r="1.9" stroke={textSecondary} strokeWidth="0.2" />
          <circle cx="89.3793" cy="147.57" r="2" fill="white" />
          <circle cx="89.3793" cy="147.57" r="1.9" stroke={textSecondary} strokeWidth="0.2" />
          <path d="M71.3793 95.5695C71.3793 95.0172 71.827 94.5695 72.3793 94.5695H250.379C250.932 94.5695 251.379 95.0172 251.379 95.5695V109.57H71.3793V95.5695Z" fill={primaryColor} />
        </g>
        <rect x="71.8793" y="95.0695" width="157.621" height="184.43" rx="1.5" stroke={borderColor} />
      </g>
      <defs>
        <filter id="filter0_d" x="67.3793" y="94.5695" width="166.621" height="193.43" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <clipPath id="clip0">
          <rect x="71.3793" y="94.5695" width="158.621" height="185.43" rx="2" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
